export enum DeviceBodypackMicrophoneMode {
	Internal = 'INTERNAL',
	External = 'EXTERNAL'
}
